import { useState, useEffect } from 'react';
import Application from './Application';
import PersonalForms from './PersonalForms';
import Work from './Work';
import Tertiary from './Tertiary';
import Academics from './Academics';
import { FaLongArrowAltLeft, FaLongArrowAltRight } from 'react-icons/fa';
import Files from './Files';
import PreviewApplication from './PreviewApplication';
import M from 'materialize-css/dist/js/materialize.min';
import { Helmet } from 'react-helmet';
import { ImUpload } from "react-icons/im";
import { applicationAction } from '../../Firebase/actions/applicationAction';
import { connect } from 'react-redux';
import { useFirebase } from 'react-redux-firebase';

const ApplicationLayout = ({ applicationAction, applicationSuccess, applicationError }) => {
    const [ nextBtn, setNextBtn ] = useState(false);
    const [ nextBtn2, setNextBtn2 ] = useState(false);
    const [ nextBtn3, setNextBtn3 ] = useState(false);
    const [ nextBtn4, setNextBtn4 ] = useState(false);
    const [ nextBtn5, setNextBtn5 ] = useState(false);
    const [ nextBtn6, setNextBtn6 ] = useState(false);

    const [ progressCounter, setprogressCounter ] = useState(1);
    const [programme1, setProgramme1] = useState('');
    const [programme2, setProgramme2] = useState('');
    const [programme3, setProgramme3] = useState('');
    const [mode, setMode] = useState('');
    const [level, setLevel] = useState('');

    const [title, setTitle] = useState('');
    const [ forenames, setForeNames ] = useState('');
    const [ surname, setSurname ] = useState('');
    const [ dob, setDob ] = useState('');
    const [ gender, setGender ] = useState('');
    const [ maritalStatus, setMaritalStatus ] = useState('');
    const [ placeOfBirth, setPlaceOfBirth ] = useState('');
    const [ nationality, setNationality ] = useState('');
    const [ citizenship, setCitizenship ] = useState('');
    const [ idNumber, setIdNumber ] = useState('');
    const [ email, setEmail ] = useState('');
    const [ phoneNumber, setPhoneNumber ] = useState('');
    const [ address, setAddress ] = useState('');

    const [ ordLevel, setOrdLevel ] = useState([]);
    const [ month, setMonth ] = useState('');
    const [ year, setYear ] = useState('');
    const [ subject, setSubject ] = useState('');
    const [ board, setBoard ] = useState('');
    const [ grade, setGrade ] = useState('');

    const [ tertiary, setTertiary ] = useState([]);
    const [ tertiaryLevel, setTertiaryLevel ] = useState('');
    const [ course, setCourse ] = useState('');
    const [ tertiaryYear, setTertiaryYear ] = useState('');

    const [ work, setWork ] = useState([]);
    const [ fromDate, setFromDate ] = useState('');
    const [ toDate, setToDate ] = useState('');
    const [ occupation, setOccupation ] = useState('');
    const [ employerName, setEmployerName ] = useState('');
    const [ workAddress, setWorkAddress ] = useState('');

    const [files, setFiles] = useState(null);
    const [error, setError] = useState(null);
    // const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
    const [uploadFileErr, setUploadFileErr] = useState(null);


    const firebase = useFirebase();

    const submitApplication = () => {

        // storagee references
        const storageRef = firebase.storage().ref(`applications/${files.name}`);


        storageRef.put(files).on('state change', (snap) => {
            document.getElementById('Btn').innerHTML = '';
            document.getElementById('Btn').classList.add('is-loading');
        }, (err) => {
            setUploadFileErr(err.code);
        }, async () => {
            document.getElementById('Btn').innerHTML = 'Loading...';
            document.getElementById('Btn').classList.remove('is-loading');

            const uploadedFileUrl = await storageRef.getDownloadURL();
            //setUploadedFileUrl(url);
          
                let data = await {
                    programme1, 
                    programme2, 
                    programme3, 
                    mode, 
                    level, 
                    title, 
                    forenames, 
                    surname, 
                    dob, 
                    gender, 
                    maritalStatus, 
                    placeOfBirth, 
                    nationality, 
                    citizenship, 
                    idNumber, 
                    email, 
                    phoneNumber, 
                    address, 
                    ordLevel,
                    tertiary,
                    work,
                    applicationStatus: 'pending',
                    uploadedFileUrl,
                    time: new Date()
    
                }
                applicationAction(data);
            
           
        }); 
    }

    useEffect(() => {
        // //modal init
        var elems = document.querySelectorAll('.modal');
        M.Modal.init(elems, {

        });

         //onSuccess 
        if(applicationSuccess) {
            document.getElementById('Btn').innerHTML = 'Completed Application';
           
            var successModal = document.getElementById('successModal');

            var instance = M.Modal.init(successModal, {
                onCloseEnd: () => {
                    document.getElementById('Btn').classList.remove('is-loading');
                    window.location.assign("https://lifelongpolytechnic.co.zw");
                }
            });
            instance.open();
            //console.log('run')
        }

         //on error
        if(applicationError) {
            
            var errorModal = document.getElementById('errorModal');

            var closing = M.Modal.init(errorModal, {
                onCloseEnd: () => {
                    document.getElementById('Btn').classList.remove('is-loading');
                }
            });
            closing.open();

        }

        //check info form data 1 ||
        if(programme1 !== '' && programme2 !== '' && programme3 !== '' && mode !== '' && level !== '' && progressCounter === 1 ){
            setNextBtn(true);
        } else {
            setNextBtn(false);
        }

        if(title !== '' && forenames !== '' && surname !== '' && dob !== '' && gender !== '' && maritalStatus !== '' && placeOfBirth !== '' && forenames !== '' && nationality !== '' && citizenship !== '' && idNumber !== '' && email !== '' && phoneNumber !== '' && address !== '' && progressCounter === 2) {
            setNextBtn2(true);
        } else {
            setNextBtn2(false);
        }

        if(ordLevel.length >= 5 && progressCounter === 3) {
            setNextBtn3(true);
        } else {
            setNextBtn3(false);
        }
        
        if( progressCounter === 4 ) {
            setNextBtn4(true);
        } else {
            setNextBtn4(false);
        }

        if( progressCounter === 5 ) {
            setNextBtn5(true);
        } else {
            setNextBtn5(false);
        }

        if( files !== null && progressCounter === 6 ) {
            setNextBtn6(true);
        } else {
            setNextBtn6(false);
        }

         
    }, [ applicationError, applicationSuccess,  files, programme1, programme2, programme3, mode, level, progressCounter, title, forenames, surname, dob, gender, maritalStatus, placeOfBirth, nationality, citizenship, idNumber, email, phoneNumber, address, ordLevel]);

    return ( 
        <>
            <Helmet> 
                <meta
                    name="description"
                    content="Our portal allows you to apply online from anywhere around the world."
                />
                <title>Online Application</title>
            </Helmet>
            <div className="wrapper light-bg">
                <nav className="nav-extended main-bg z-depth-0">
                    <div className="nav-wrapper">
                        <div className="brand-logo center is-size-5-touch is-size-4-desktop"><span className="hide-on-med-and-down">Life Long Polytechnic</span> Online Application</div>
                    </div>
                </nav>

                <div className="container">
                    <form>
                        { progressCounter === 1 && <Application mode={mode} level={level} programme1={programme1} programme2={programme2} programme3={programme3} setProgramme1={setProgramme1} setProgramme2={setProgramme2} setProgramme3={setProgramme3} setMode={setMode} setLevel={setLevel}/> }
                        { progressCounter === 2 && <PersonalForms title={title}   setTitle={setTitle}  forenames={forenames} 
                                setForeNames={setForeNames} surname={surname} setSurname={setSurname} dob={dob} setDob={setDob} gender={gender} 
                                setGender={setGender}  maritalStatus={maritalStatus} setMaritalStatus={setMaritalStatus} 
                                placeOfBirth={placeOfBirth} setPlaceOfBirth={setPlaceOfBirth} nationality={nationality} setNationality={setNationality}
                                citizenship={citizenship} setCitizenship={setCitizenship} idNumber={idNumber} setIdNumber={setIdNumber} email={email} 
                                setEmail={setEmail} phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} address={address} setAddress={setAddress}
                            /> 
                        }
                        { progressCounter === 3 && <Academics ordLevel={ordLevel} setOrdLevel={setOrdLevel} month={month} setMonth={setMonth}
                                year={year} setYear={setYear} subject={subject} setSubject={setSubject} board={board} setBoard={setBoard} grade={grade} setGrade={setGrade}
                            /> 
                        }
                        { progressCounter === 4 && <Tertiary tertiary={tertiary} setTertiary={setTertiary} tertiaryLevel={tertiaryLevel} setTertiaryLevel={setTertiaryLevel} 
                                course={course} setCourse={setCourse} tertiaryYear={tertiaryYear} setTertiaryYear={setTertiaryYear}
                            /> 
                        }
                        { progressCounter === 5 && <Work work={work} setWork={setWork} fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} 
                                occupation={occupation} setOccupation={setOccupation} employerName={employerName} setEmployerName={setEmployerName} workAddress={workAddress} setWorkAddress={setWorkAddress}
                            /> 
                        }
                        { progressCounter === 6 && <Files files={files} setFiles={setFiles} error={error} setError={setError} /> }
                        { progressCounter === 7 && <PreviewApplication mode={mode} level={level} programme1={programme1} programme2={programme2} programme3={programme3}
                                setTitle={setTitle}  forenames={forenames} setForeNames={setForeNames} surname={surname} dob={dob} gender={gender} maritalStatus={maritalStatus}
                                placeOfBirth={placeOfBirth} nationality={nationality}  citizenship={citizenship} idNumber={idNumber} email={email} phoneNumber={phoneNumber} address={address}
                                ordLevel={ordLevel} tertiary={tertiary}  work={work} files={files}
                            /> 
                        }
                    </form>
                    <div className="my-4 field is-grouped">
                        { 
                            progressCounter !== 1 && (
                                <div className="control">
                                    <div
                                        className="button is-info mt-3"
                                        onClick={() => {
                                                if(mode === "Full Time" && progressCounter === 6) {
                                                    setprogressCounter(3);
                                                } else {
                                                    setprogressCounter(progressCounter - 1);
                                                }
                                            } 
                                        }
                                    >
                                        <span className="icon">
                                            <FaLongArrowAltLeft color="white"/>
                                        </span>
                                        <span className="white-text">Previous</span>
                                    </div>
                                </div>
                            )
                        }
                        {/* next buttons */}  

                        { 
                            nextBtn && (
                            <div className="control">
                                <div
                                    className="button is-success mt-3"
                                    onClick={() => setprogressCounter(progressCounter + 1) }
                                >
                                    <span className="white-text">Next</span>
                                    <span className="icon">
                                        <FaLongArrowAltRight color="white"/>
                                    </span>
                                </div>
                            </div>
                        )
                        }
                        { 
                            nextBtn2 && (
                            <div className="control">
                                <div
                                    className="button is-success mt-3"
                                    onClick={() => setprogressCounter(progressCounter + 1) }
                                >
                                    <span className="white-text">Next</span>
                                    <span className="icon">
                                        <FaLongArrowAltRight color="white"/>
                                    </span>
                                </div>
                            </div>
                        )
                        }
                        { 
                            nextBtn3 && (
                            <div className="control">
                                <div
                                    className="button is-success mt-3"
                                    onClick={() => {
                                            if(mode !== "Full Time") {
                                                setprogressCounter(progressCounter + 1);
                                            } else {
                                                setprogressCounter(6);
                                            }
                                        } 
                                    }
                                >
                                    <span className="white-text">Next</span>
                                    <span className="icon">
                                        <FaLongArrowAltRight color="white"/>
                                    </span>
                                </div>
                            </div>
                        )
                        }
                        { 
                            nextBtn4 && (
                            <div className="control">
                                <div
                                    className="button is-success mt-3"
                                    onClick={() => setprogressCounter(progressCounter + 1) }
                                >
                                    <span className="white-text">Next</span>
                                    <span className="icon">
                                        <FaLongArrowAltRight color="white"/>
                                    </span>
                                </div>
                            </div>
                        )
                        }
                        { 
                            nextBtn5 && (
                            <div className="control">
                                <div
                                    className="button is-success mt-3"
                                    onClick={() => setprogressCounter(progressCounter + 1) }
                                >
                                    <span className="white-text">Next</span>
                                    <span className="icon">
                                        <FaLongArrowAltRight color="white"/>
                                    </span>
                                </div>
                            </div>
                        )
                        }
                        { 
                            nextBtn6 && (
                            <div className="control">
                                <div
                                    className="button is-success mt-3" 
                                    onClick={() => setprogressCounter(progressCounter + 1) }
                                >
                                    <span className="white-text">Next</span>
                                    <span className="icon">
                                        <FaLongArrowAltRight color="white"/>
                                    </span>
                                </div>
                            </div>
                        )
                        }
                        {/* end of next buttons */}
                        
                        {/* complete application btn */}
                        { 
                            progressCounter === 7 && (
                            <div className="control">
                                <div
                                    className="button is-success mt-3"
                                    onClick={submitApplication}
                                    id="Btn"
                                >
                                    <span className="icon">
                                        <ImUpload color="white"/>
                                    </span>
                                    <span className="white-text">Complete Application</span>
                                </div>
                            </div>
                        )
                        }
                        {
                            uploadFileErr && <p className="red-text text-darken-3">{uploadFileErr}</p>
                        }
                    </div>
                </div>
            </div>
        </>
     );
}

const mapStateToProps = (state) => {
    console.log(state)
    return {
        applicationSuccess: state.application.applicationSuccess,
        applicationError: state.application.applicationError
    }
    
}
 

const mapDispatchToProps = (dispatch) => {
    
    return {
        applicationAction: (application) => dispatch(applicationAction(application)),
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(ApplicationLayout);